import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Icon, Confirm } from "rhombus-react";
import { noop } from "utils/common";

import "./MappingActions.css";

function Description({ mappingName }) {
	const hasMappingName = Boolean(mappingName?.trim());
	const mappingDeleteTarget = hasMappingName ? <><b>“{mappingName}”</b></> : "this mapping";
	return <p>Are you sure you want to delete {mappingDeleteTarget}?<br /></p>;
}

export default function MappingActions({ dependentValues = {} }) {
	const dispatch = useDispatch();
	const { id, rowIndex, onDelete = noop, mappingName = "this mapping" } = dependentValues;

	const handleDelete = () => {
		dispatch(Confirm.openConfirmAction({
			title: "Delete Mapping",
			className: "delete-mapping-confirm",
			desc: (<Description mappingName={mappingName} />),
			commitLabel: "Delete",
			commitTheme: "red",
			onCommit: () => {
				onDelete(id, rowIndex);
				return Promise.resolve({ success: true });
			},
		}));
	};

	return (
		<div className="mapping-actions-container">
			<button
				type="button"
				className="delete-mapping-button"
				onClick={handleDelete}
				data-tip="Delete Mapping"
			>
				<Icon
					name="far fa-trash-alt"
					className="delete-mapping-icon"
				/>
			</button>
		</div>
	);
}

MappingActions.displayName = "MappingActions";

MappingActions.propTypes = {
	dependentValues: PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		rowIndex: PropTypes.number.isRequired,
		onDelete: PropTypes.func,
		mappingName: PropTypes.string,
	}),
};
